import type { SVGProps } from "react";

export const Email = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.00002 2.5H18C18.221 2.5 18.433 2.5878 18.5893 2.74408C18.7456 2.90036 18.8334 3.11232 18.8334 3.33333V16.6667C18.8334 16.8877 18.7456 17.0996 18.5893 17.2559C18.433 17.4122 18.221 17.5 18 17.5H3.00002C2.77901 17.5 2.56704 17.4122 2.41076 17.2559C2.25448 17.0996 2.16669 16.8877 2.16669 16.6667V3.33333C2.16669 3.11232 2.25448 2.90036 2.41076 2.74408C2.56704 2.5878 2.77901 2.5 3.00002 2.5ZM10.55 9.73583L5.20669 5.19833L4.12752 6.46833L10.5609 11.9308L16.8784 6.46417L15.7884 5.20333L10.55 9.73583Z" />
  </svg>
);
